import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Auth = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Προσθήκη του loading state
    const navigate = useNavigate();

    useEffect(() => {
        const decodedToken = sessionStorage.getItem("token");

        if (decodedToken) {
            try {

                // Ελέγχουμε αν το token έχει λήξει
                const currentTime = Date.now() / 1000;
                if (decodedToken.exp < currentTime) {
                    console.warn("Token expired");
                    sessionStorage.removeItem("userToken");
                    setUser(null);
                    navigate("/"); // Ανακατεύθυνση αν το token είναι ληγμένο
                } else {
                    setUser(decodedToken); // Αν το token είναι έγκυρο
                }
            } catch (error) {
                console.error("Invalid token:", error);
                sessionStorage.removeItem("userToken");
                setUser(null);
                navigate("/"); // Αν το token είναι άκυρο
            }
        } else {
            setUser(null); // Αν δεν υπάρχει token
        }

        setLoading(false); // Ολοκλήρωση της διαδικασίας φόρτωσης
    }, [navigate]); // Εκτελείται μόνο όταν γίνεται ανανέωση

    const login = (token) => {
        sessionStorage.setItem("userToken", token); // Αποθήκευση του token στο sessionStorage
        const decodedToken = jwtDecode(token);
        setUser(decodedToken); // Ενημέρωση του χρήστη στο Auth
        toast.success("Login Successful!");
        // Redirect με βάση τον ρόλο
        if (decodedToken.role === "VISITOR") {
            navigate("/profile-menu-visitor"); // Στην αρχική σελίδα για χρήστες "REGISTERED"
        } else if (decodedToken.role === "PROVIDER") {
            navigate("/profile-menu-provider"); // Στη σελίδα του παρόχου για χρήστες "PROVIDER"
        } else if (decodedToken.role === "ADMIN") {
            navigate("/profile-menu-admin"); // Στη σελίδα διαχείρισης για χρήστες "ADMIN"
        }
    };

    const logout = () => {
        sessionStorage.removeItem("token"); // Αφαίρεση του token από το sessionStorage
        setUser(null); // Ενημέρωση του χρήστη στην κατάσταση του Auth
        // window.alert("Logout Successful!");
         // Show toast message
        toast.success("Logout Successful!");

        navigate("/register-signIn"); // Επιστροφή στην αρχική σελίδα

    };

    return (
        <Auth.Provider value={{ user, login, logout }}>
            {loading ? (
                <div>Loading...</div> // Εμφανίζουμε ένα loading indicator ενώ περιμένουμε
            ) : (
                children
            )}
        </Auth.Provider>
    );
};

export const useAuth = () => useContext(Auth);



